<template>
  <div class="db">
    <div class="footer">
      <div class="sydw"><img src="../assets/images/sydw.png" /></div>
      <div class="dbwz">
        <div>互联网信息服务备案号：粤ICP 备05013162 号</div>
        <div>本网站由广东水科院网络中心设计、维护</div>
        <div>地址：广州市天河区天寿路116号、广东水利大厦B座</div>
        <!--<div>您是第<span class="fwrs">6632578</span>位访问者</div>-->
      </div>
      <div class="aw"><img src="../assets/images/aw.png" /></div>
      <div class="zat"><img src="../assets/images/zat.png" /></div>
      <div class="skygzh"><img src="../assets/images/sky.png" /></div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "bottom"
    }
</script>

<style scoped>
  @import '../assets/css/bottom.css';
</style>



// WEBPACK FOOTER //
// src/components/bottom.vue